import { Link } from 'react-router-dom';

import logo from '../assets/logo.png';
import paypal from '../assets/logo/Paypal.png';
import visa from '../assets/logo/Visa.png';
import mastercard from '../assets/logo/Mastercard.png';
import bancontact from '../assets/logo/Bancontact.png';

import { CONTACT, FOOTER_LINKS, SITE, whatsappLink } from '../config/site';

const PAYMENT_METHODS = [
    { src: visa, name: 'Visa' },
    { src: mastercard, name: 'Mastercard' },
    { src: paypal, name: 'PayPal' },
    { src: bancontact, name: 'Bancontact' },
];

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="border-t border-line bg-ink-950 pt-16 pb-8 print:hidden">
            <div className="container">
                <div className="grid grid-cols-2 gap-10 lg:grid-cols-12 lg:gap-8">
                    {/* Brand */}
                    <div className="col-span-2 lg:col-span-4">
                        <Link to="/" className="inline-flex items-center" aria-label={`${SITE.name} — accueil`}>
                            <img src={logo} alt={SITE.name} width="56" height="56" className="h-12 w-auto rounded-md" />
                        </Link>
                        <p className="mt-5 max-w-sm leading-relaxed text-content-muted">
                            {SITE.description}
                        </p>
                        <a
                            href={whatsappLink()}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-6 inline-flex items-center gap-2 rounded-full border border-line px-4 py-2 text-sm font-semibold text-white transition-colors hover:border-line-strong hover:bg-white/[0.06]"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967c-.273-.099-.471-.148-.67.15c-.197.297-.767.966-.94 1.164c-.173.199-.347.223-.644.075c-.297-.15-1.255-.463-2.39-1.475c-.883-.788-1.48-1.761-1.653-2.059c-.173-.297-.018-.458.13-.606c.134-.133.298-.347.446-.52c.149-.174.198-.298.298-.497c.099-.198.05-.371-.025-.52c-.075-.149-.669-1.612-.916-2.207c-.242-.579-.487-.5-.669-.51c-.173-.008-.371-.01-.57-.01c-.198 0-.52.074-.792.372c-.272.297-1.04 1.016-1.04 2.479c0 1.462 1.065 2.875 1.213 3.074c.149.198 2.096 3.2 5.077 4.487c.709.306 1.262.489 1.694.625c.712.227 1.36.195 1.871.118c.571-.085 1.758-.719 2.006-1.413c.248-.694.248-1.289.173-1.413c-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214l-3.741.982l.998-3.648l-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884c2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                            </svg>
                            Support WhatsApp
                        </a>
                    </div>

                    {/* Navigation */}
                    <nav aria-labelledby="footer-nav" className="lg:col-span-3">
                        <h2 id="footer-nav" className="mb-5 text-sm font-bold uppercase tracking-wider text-white">
                            Navigation
                        </h2>
                        <ul className="space-y-3">
                            {FOOTER_LINKS.navigation.map((link) => (
                                <li key={link.href}>
                                    <Link
                                        to={link.href}
                                        className="text-content-muted transition-colors hover:text-brand"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Legal */}
                    <nav aria-labelledby="footer-legal" className="lg:col-span-2">
                        <h2 id="footer-legal" className="mb-5 text-sm font-bold uppercase tracking-wider text-white">
                            Légal
                        </h2>
                        <ul className="space-y-3">
                            {FOOTER_LINKS.legal.map((link) => (
                                <li key={link.href}>
                                    <Link
                                        to={link.href}
                                        className="text-content-muted transition-colors hover:text-brand"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Contact + payment */}
                    <div className="col-span-2 lg:col-span-3">
                        <h2 className="mb-5 text-sm font-bold uppercase tracking-wider text-white">Contact</h2>
                        <ul className="space-y-3">
                            <li>
                                <a
                                    href={`mailto:${CONTACT.email}`}
                                    className="text-content-muted transition-colors hover:text-brand"
                                >
                                    {CONTACT.email}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={whatsappLink()}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-content-muted transition-colors hover:text-brand"
                                >
                                    {CONTACT.whatsappDisplay}
                                </a>
                            </li>
                        </ul>

                        <h2 className="mb-4 mt-8 text-sm font-bold uppercase tracking-wider text-white">
                            Paiement
                        </h2>
                        <ul className="flex flex-wrap items-center gap-2.5">
                            {PAYMENT_METHODS.map((method) => (
                                <li
                                    key={method.name}
                                    className="grid h-9 w-14 place-items-center rounded-lg border border-line bg-white/[0.04] px-2"
                                >
                                    <img
                                        src={method.src}
                                        alt={method.name}
                                        loading="lazy"
                                        className="max-h-5 w-full object-contain"
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-line pt-6 sm:flex-row">
                    <p className="text-sm text-content-subtle">
                        © {currentYear} {SITE.name}. Tous droits réservés.
                    </p>
                    <p className="flex items-center gap-2 text-sm text-content-muted">
                        <span className="h-2 w-2 rounded-full bg-success" aria-hidden="true" />
                        Support disponible 7j/7
                    </p>
                </div>
            </div>
        </footer>
    );
}
